'use strict'

/**
 * General purpose site-specific features for kansallinenaivoterveysohjelma.fi.
 *
 * @version 1.0.0
 */
class KansallinenAivoterveysOhjelma {

	/**
	 * Class constructor
	 *
	 * @param {Object} options Options for the class.
	 */
	constructor(options = {}) {
		this.options = {}

		// Init polyfills
		const polyfills = new Polyfills()
		polyfills.init()

		const offCanvas = new OffCanvas({
			debug: false,
			overlay: true
		})

		// Initialize
		this.init(options)
	}

	/**
	 * Init the class by calling applicable init methods
	 *
	 * @param {Object} options Options for the class.
	 * @return {Object}
	 */
	init(options = {}) {
		// Merge user options to the defaults
		this.options = {
			responsiveTables: {
				selector: 'main table'
			},
			imageLinks: {
				parentSelector: 'main'
			},
			...options
		}

		// Call individual init methodsat-
		this.initResponsiveTables()
		this.initSkipLinks()
		this.initMainNav()
		this.initImageLinks()

		// Dispatch custom event when init is done
		document.dispatchEvent(
			new CustomEvent('site-init-done', {
				bubbles: true,
				cancelable: true
			})
		)

		return this
	}

	/**
	 * Initialize responsive tables
	 *
	 * Finds content tables and wraps them with div.table-wrapper.
	 */
	initResponsiveTables() {
		document.querySelectorAll(this.options.responsiveTables.selector).forEach(table => {
			if (!table.closest('.table-wrapper')) {
				const tableWrapper = document.createElement('div')
				tableWrapper.classList.add('table-wrapper')
				tableWrapper.classList.add('overflow-x-auto')
				table.parentNode.insertBefore(tableWrapper, table)
				tableWrapper.appendChild(table)
			}
		})
	}

	/**
	 * Initialize skip links
	 *
	 * Finds skip links and enhances their behaviour for various screen readers and mobile devices.
	 */
	initSkipLinks() {
		const skipLinks = document.querySelectorAll('.skip-link:not([data-skip-link])')
		if (skipLinks.length) {
			const skipToBlur = event => {
				if (event.target.getAttribute('data-tabindex')) {
					event.target.removeAttribute('tabindex')
					event.target.removeAttribute('data-tabindex')
				}
			}
			skipLinks.forEach(skipLink => {
				skipLink.setAttribute('data-skip-link', true)
				skipLink.addEventListener('click', event => {
					const skipTo = document.getElementById(event.target.href.split('#')[1])
					if (skipTo && skipTo.getAttribute('tabindex') != '-1') {
						event.preventDefault()
						skipTo.setAttribute('tabindex', '-1')
						skipTo.setAttribute('data-tabindex', true)
						skipTo.addEventListener('blur', skipToBlur)
						skipTo.addEventListener('focusout', skipToBlur)
						skipTo.focus()
					}
				})
			})
		}
	}

	initMainNav() {
		const navs = document.querySelectorAll('.mainNav')
		if (!navs.length) return

		for (const nav of navs) {
			const subLists = nav.querySelectorAll('.mainNav__list--level-2')
			if (!subLists.length) return

			let subListCounter = 0

			for (const subList of subLists) {
				subListCounter++
				const subListId = `mainNav__sublist-${subListCounter}`
				subList.setAttribute('id', subListId)

				const button = document.createElement('button')
				button.classList.add('mainNav__toggleButton')
				button.setAttribute('aria-label', 'Näytä alasivut')
				button.setAttribute('aria-expanded', false)
				button.setAttribute('aria-controls', subListId)

				const buttonText = document.createElement('span')
				buttonText.setAttribute('aria-hidden', true)
				buttonText.textContent = '▼'
				button.appendChild(buttonText)

				button.addEventListener('click', e => {
					button.setAttribute('aria-expanded', button.getAttribute('aria-expanded') == 'true' ? false : true)
					button.setAttribute('aria-label', button.getAttribute('aria-expanded') == 'true' ? 'Piilota alasivut' : 'Näytä alasivut')

					if (button.getAttribute('aria-expanded') == 'true') {
						const openNavs = nav.querySelectorAll('.mainNav__toggleButton[aria-expanded="true"]')

						for (const item of openNavs) {
							if (item === button) continue

							item.dispatchEvent(new Event('click'))
						}

						subList.classList.add('mainNav__list--visible')
						subList.focus()
					} else {
						subList.classList.remove('mainNav__list--visible')
					}
				})

				subList.parentElement.insertBefore(button, subList)
			}
		}
	}

	/**
	 * Initialize image links
	 *
	 * Find all links to images and use GLightbox to display them.
	 */
	initImageLinks() {
		let parentNode = document.querySelector(this.options.imageLinks.parentSelector);

		if (!parentNode) return;

		parentNode.querySelectorAll('a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"]').forEach(link => {
			let figcaption = link.parentNode.querySelector('figcaption');
			let caption = figcaption ? figcaption.textContent : '';

			link.addEventListener('click', e => {
				e.preventDefault();

				const lightbox = GLightbox();
				lightbox.setElements([
					{
						href: link.href,
						type: 'image',
						title: caption
					}
				]);

				lightbox.open();
			});
		});
	}
}

window._site = new KansallinenAivoterveysOhjelma()
